import { isProduction } from "helpers/isProduction";

import IConfig from "interfaces/IConfig";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "Portal.translate";
export const url = "translate";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active:
            permissions["portal.translation"] &&
            permissions["translation.read"],
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (config.active) {
        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Translate/pages/TranslateIndexPage" />
            ),
        });
        if (permissions["translation.compare.update"] && isProduction()) {
            routing.push({
                path: `${url}/compare`,
                element: (
                    <AsyncComponent path="Translate/pages/TranslateComparePage" />
                ),
            });
        }
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
